/**
 * Pomocná funkce pro zpracování názvu souboru z hodnoty atributu.
 * Pokud je hodnota řetězec, vrací text za poslední dvojtečkou.
 * V případě že se v řetězci dvojtečka nevyskytuje, vrací celý řetězec.
 * V ostatních případech vrací undefined.
 * @param value Hodnota atributu
 */
export const getFilename = (value: any): string | undefined => {
    if (typeof value === "string") {
        const lastColon = value.lastIndexOf(":");
        return lastColon !== -1 ? value.substr(lastColon + 1) : value;
    }
    return undefined;
};
